import { GhePage4Payload, ProcessCurveView, TargetRockPage4View } from '../../@types/ghePage4/types';

export const selectionKey = (rockId: string, process: string) =>
  `${rockId}::${process}`;

const seriesSourceId = (label: string) =>
  label.includes('::') ? label.split('::', 1)[0] : label;

export const buildSelectionState = (payload: GhePage4Payload | null) => {
  const state: Record<string, string[]> = {};
  if (!payload) {
    return state;
  }

  payload.rocks.forEach(rock => {
    rock.process_views.forEach(view => {
      state[selectionKey(rock.rock_id, view.process)] = [...view.selected_analogues];
    });
  });
  return state;
};

export const updateSelectionState = (
  prev: Record<string, string[]>,
  rockId: string,
  process: string,
  selected: string[]
) => ({
  ...prev,
  [selectionKey(rockId, process)]: [...selected]
});

const filterSeriesBySelection = (view: ProcessCurveView, selected: string[]) => {
  if (selected.length === 0) {
    return [];
  }
  const selectedSet = new Set(selected);
  return view.series.filter(series => selectedSet.has(seriesSourceId(series.label)));
};

export const applySelectionsToPayload = (
  payload: GhePage4Payload | null,
  selectedByProcess: Record<string, string[]>
): GhePage4Payload | null => {
  if (!payload) {
    return null;
  }

  const rocks: TargetRockPage4View[] = payload.rocks.map(rock => {
    const processViews = rock.process_views.map(view => {
      const key = selectionKey(rock.rock_id, view.process);
      const selected = selectedByProcess[key] ?? view.selected_analogues;
      return {
        ...view,
        selected_analogues: [...selected],
        series: filterSeriesBySelection(view, selected)
      };
    });
    return {
      ...rock,
      process_views: processViews
    };
  });

  return {
    ...payload,
    rocks
  };
};
